import { render, staticRenderFns } from "./OnCallTab.vue?vue&type=template&id=101c3c30&"
import script from "./OnCallTab.vue?vue&type=script&lang=js&"
export * from "./OnCallTab.vue?vue&type=script&lang=js&"
import style0 from "./OnCallTab.vue?vue&type=style&index=0&id=101c3c30&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports